"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_TO_FILTER_MAPPING = exports.FILTER_ORDER_MAPPING = exports.GROUP_FILTER_TEMPLATE_BY_FILTER_ID = void 0;
const search_1 = require("src/search");
const FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
const segmentFilterTemplate = {
    guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
    newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
    isCollapsed: false,
    isSearchable: false,
    titleProp: '',
    typeAlias: FilterTypings_1.FilterGroupTypeAlias.Segment,
};
exports.GROUP_FILTER_TEMPLATE_BY_FILTER_ID = {
    [search_1.FullTextSearchFilters.TypeFilterId]: {
        filters: [
            { type: search_1.FullTextSearcherTypes.Products, labelProp: 'productsLabel', priority: 1 },
            { type: search_1.FullTextSearcherTypes.Documentation, labelProp: 'documentationLabel', priority: 2 },
            { type: search_1.FullTextSearcherTypes.Drawings, labelProp: 'drawingsLabel', priority: 3 },
            { type: search_1.FullTextSearcherTypes.Download, labelProp: 'downloadsLabel', priority: 4 },
            { type: search_1.FullTextSearcherTypes.Careers, labelProp: 'careersLabel', priority: 5 },
            { type: search_1.FullTextSearcherTypes.Course, labelProp: 'courseLabel', priority: 6 },
        ],
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'type',
        type: search_1.FullTextSearchFilters.TypeFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.Type,
        value: search_1.FullTextSearchFilters.TypeFilterAlias,
        unselectable: true,
    },
    /////////////////////////
    // ALL RESULTS FILTERS //
    [search_1.FullTextSearchFilters.AllSegmentFilterId]: Object.assign(Object.assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.AllSegmentFilterAlias, value: search_1.FullTextSearchFilters.AllSegmentFilterAlias, isSearchable: true }),
    ///////////////////////////
    // DOCUMENTATION FILTERS //
    [search_1.FullTextSearchFilters.DocumentationSegmentFilterId]: Object.assign(Object.assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.DocumentationSegmentFilterAlias, value: search_1.FullTextSearchFilters.DocumentationSegmentFilterAlias, isSearchable: true }),
    [search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'documentTypes',
        type: search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias,
        value: search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias,
    },
    [search_1.FullTextSearchFilters.DocumentationProductionSiteId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        titleProp: 'productionSite',
        type: search_1.FullTextSearchFilters.DocumentationProductionSiteAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductionSite,
        value: search_1.FullTextSearchFilters.DocumentationProductionSiteAlias,
    },
    [search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        isHidden: true,
        isDisabled: false,
        titleProp: 'approvalType',
        type: search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias,
        value: search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias,
    },
    [search_1.FullTextSearchFilters.DocumentationLanguageFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: true,
        isSearchable: false,
        titleProp: 'languages',
        type: search_1.FullTextSearchFilters.DocumentationLanguageFilterAlias,
        value: search_1.FullTextSearchFilters.DocumentationLanguageFilterAlias,
    },
    [search_1.FullTextSearchFilters.DocumentationCountryFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        labelProp: 'validForLabel',
        placeholder: 'validForAllCountries',
        titleProp: 'country',
        type: search_1.FullTextSearchFilters.DocumentationCountryFilterAlias,
        value: search_1.FullTextSearchFilters.DocumentationCountryFilterAlias,
    },
    [search_1.FullTextSearchFilters.DocumentationHierarchyFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'hierarchy',
        type: search_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.Hierarchy,
        value: search_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias,
    },
    [search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'hierarchy',
        type: search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy,
        value: search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias,
    },
    [search_1.FullTextSearchFilters.DocumentationProductSeriesFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productSeries',
        type: search_1.FullTextSearchFilters.DocumentationProductSeriesFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductSeries,
        value: search_1.FullTextSearchFilters.DocumentationProductSeriesFilterAlias,
    },
    [search_1.FullTextSearchFilters.DocumentationAuthorityFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'authorityLabel',
        titleProp: 'authority',
        type: search_1.FullTextSearchFilters.DocumentationAuthorityFilterAlias,
        value: search_1.FullTextSearchFilters.DocumentationAuthorityFilterAlias,
    },
    [search_1.FullTextSearchFilters.DocumentationProductGroupFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productGroup',
        type: search_1.FullTextSearchFilters.DocumentationProductGroupFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductGroup,
        value: search_1.FullTextSearchFilters.DocumentationProductGroupFilterAlias,
    },
    [search_1.FullTextSearchFilters.DocumentationArchivedFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        titleProp: 'archivedGroup',
        type: search_1.FullTextSearchFilters.DocumentationArchivedFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.Archived,
        value: search_1.FullTextSearchFilters.DocumentationArchivedFilterAlias,
    },
    //////////////////////
    // PRODUCTS FILTERS //
    [search_1.FullTextSearchFilters.ProductsSegmentFilterId]: Object.assign(Object.assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.ProductsSegmentFilterAlias, value: search_1.FullTextSearchFilters.ProductsSegmentFilterAlias, isSearchable: true }),
    //////////////////////
    // DOWNLOAD FILTERS //
    [search_1.FullTextSearchFilters.DownloadSegmentFilterId]: Object.assign(Object.assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.DownloadSegmentFilterAlias, value: search_1.FullTextSearchFilters.DownloadSegmentFilterAlias, isSearchable: true }),
    [search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        placeholder: 'downloadSoftwareType',
        titleProp: 'downloadSoftwareType',
        type: search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterAlias,
        value: search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterAlias,
    },
    [search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        placeholder: 'downloadSoftwareCharacteristic',
        titleProp: 'downloadSoftwareCharacteristic',
        type: search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterAlias,
        value: search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterAlias,
    },
    [search_1.FullTextSearchFilters.DownloadProductGroupFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productGroup',
        type: search_1.FullTextSearchFilters.DownloadProductGroupFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductGroup,
        value: search_1.FullTextSearchFilters.DownloadProductGroupFilterAlias,
    },
    [search_1.FullTextSearchFilters.DownloadProductSeriesFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productSeries',
        type: search_1.FullTextSearchFilters.DownloadProductSeriesFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductSeries,
        value: search_1.FullTextSearchFilters.DownloadProductSeriesFilterAlias,
    },
    /////////////////////
    // CAREERS FILTERS //
    [search_1.FullTextSearchFilters.CareersCountryFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        placeholder: 'country',
        titleProp: 'country',
        type: search_1.FullTextSearchFilters.CareersCountryFilterAlias,
        value: search_1.FullTextSearchFilters.CareersCountryFilterAlias,
    },
    [search_1.FullTextSearchFilters.CareersLocationFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isDisabled: true,
        isHidden: true,
        isSearchable: true,
        titleProp: 'location',
        placeholder: 'location',
        type: search_1.FullTextSearchFilters.CareersLocationFilterAlias,
        value: search_1.FullTextSearchFilters.CareersLocationFilterAlias,
    },
    [search_1.FullTextSearchFilters.CareersJobAreaFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        titleProp: 'jobArea',
        type: search_1.FullTextSearchFilters.CareersJobAreaFilterAlias,
        value: search_1.FullTextSearchFilters.CareersJobAreaFilterAlias,
    },
    [search_1.FullTextSearchFilters.CareersExperienceLevelFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'experienceLevel',
        type: search_1.FullTextSearchFilters.CareersExperienceLevelFilterAlias,
        value: search_1.FullTextSearchFilters.CareersExperienceLevelFilterAlias,
    },
    ////////////////////
    // COURSE FILTERS //
    [search_1.FullTextSearchFilters.CourseSegmentFilterId]: Object.assign(Object.assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.CourseSegmentFilterAlias, value: search_1.FullTextSearchFilters.CourseSegmentFilterAlias, isSearchable: true }),
    [search_1.FullTextSearchFilters.CourseLanguageFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isDisabled: false,
        isHidden: false,
        isSearchable: false,
        titleProp: 'languages',
        type: search_1.FullTextSearchFilters.CourseLanguageFilterAlias,
        value: search_1.FullTextSearchFilters.CourseLanguageFilterAlias,
    },
    [search_1.FullTextSearchFilters.CourseHierarchyFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        isCollapsed: false,
        isDisabled: true,
        isHidden: true,
        isSearchable: false,
        labelProp: 'courseCategory',
        placeholder: 'courseCategory',
        titleProp: 'hierarchy',
        type: search_1.FullTextSearchFilters.CourseHierarchyFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.Hierarchy,
        value: search_1.FullTextSearchFilters.CourseHierarchyFilterAlias,
    },
    [search_1.FullTextSearchFilters.CourseLearningEventTypeFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: true,
        isSearchable: true,
        titleProp: 'learningEventType',
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.LearningEventType,
        type: search_1.FullTextSearchFilters.CourseLearningEventTypeFilterAlias,
        value: search_1.FullTextSearchFilters.CourseLearningEventTypeFilterAlias,
    },
    [search_1.FullTextSearchFilters.CourseDeliveryTypesFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isDisabled: false,
        isHidden: false,
        isSearchable: false,
        titleProp: 'offeredAs',
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.DeliveryTypes,
        type: search_1.FullTextSearchFilters.CourseDeliveryTypesFilterAlias,
        value: search_1.FullTextSearchFilters.CourseDeliveryTypesFilterAlias,
    },
    ////////////////////
    // DRAWINGS FILTERS //
    [search_1.FullTextSearchFilters.DrawingsSegmentFilterId]: Object.assign(Object.assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.DrawingsSegmentFilterAlias, value: search_1.FullTextSearchFilters.DrawingsSegmentFilterAlias, isSearchable: true }),
    [search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'drawingType',
        type: search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterAlias,
        value: search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterAlias,
    },
    [search_1.FullTextSearchFilters.DrawingsLanguageFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: true,
        isSearchable: false,
        titleProp: 'languages',
        type: search_1.FullTextSearchFilters.DrawingsLanguageFilterAlias,
        value: search_1.FullTextSearchFilters.DrawingsLanguageFilterAlias,
    },
    [search_1.FullTextSearchFilters.DrawingsArchivedFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        titleProp: 'archivedGroup',
        type: search_1.FullTextSearchFilters.DrawingsArchivedFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.Archived,
        value: search_1.FullTextSearchFilters.DrawingsArchivedFilterAlias,
    },
    [search_1.FullTextSearchFilters.DrawingsProductSeriesFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productSeries',
        type: search_1.FullTextSearchFilters.DrawingsProductSeriesFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductSeries,
        value: search_1.FullTextSearchFilters.DrawingsProductSeriesFilterAlias,
    },
    [search_1.FullTextSearchFilters.DrawingsProductGroupFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productGroup',
        type: search_1.FullTextSearchFilters.DrawingsProductGroupFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductGroup,
        value: search_1.FullTextSearchFilters.DrawingsProductGroupFilterAlias,
    },
    [search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterId]: {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'hierarchy',
        type: search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy,
        value: search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias,
    },
};
exports.FILTER_ORDER_MAPPING = {
    default: {
        [search_1.FullTextSearchFilters.TypeFilterId]: 1,
        [search_1.FullTextSearchFilters.AllSegmentFilterId]: 2,
    },
    [search_1.FullTextSearcherTypes.Documentation]: {
        [search_1.FullTextSearchFilters.TypeFilterId]: 1,
        [search_1.FullTextSearchFilters.DocumentationSegmentFilterId]: 2,
        [search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterId]: 3,
        [search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterId]: 4,
        [search_1.FullTextSearchFilters.DocumentationLanguageFilterId]: 5,
        [search_1.FullTextSearchFilters.DocumentationCountryFilterId]: 6,
        [search_1.FullTextSearchFilters.DocumentationHierarchyFilterId]: 7,
        [search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterId]: 8,
        [search_1.FullTextSearchFilters.DocumentationProductGroupFilterId]: 9,
        [search_1.FullTextSearchFilters.DocumentationProductSeriesFilterId]: 10,
        [search_1.FullTextSearchFilters.DocumentationArchivedFilterId]: 11,
        [search_1.FullTextSearchFilters.DocumentationAuthorityFilterId]: 12,
        [search_1.FullTextSearchFilters.DocumentationProductionSiteId]: 13,
    },
    [search_1.FullTextSearcherTypes.Products]: {
        [search_1.FullTextSearchFilters.TypeFilterId]: 1,
        [search_1.FullTextSearchFilters.ProductsSegmentFilterId]: 2,
    },
    [search_1.FullTextSearcherTypes.Download]: {
        [search_1.FullTextSearchFilters.TypeFilterId]: 1,
        [search_1.FullTextSearchFilters.DownloadSegmentFilterId]: 2,
        [search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterId]: 3,
        [search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterId]: 4,
        [search_1.FullTextSearchFilters.DownloadProductGroupFilterId]: 5,
        [search_1.FullTextSearchFilters.DownloadProductSeriesFilterId]: 6,
    },
    [search_1.FullTextSearcherTypes.Careers]: {
        [search_1.FullTextSearchFilters.TypeFilterId]: 1,
        [search_1.FullTextSearchFilters.CareersCountryFilterId]: 2,
        [search_1.FullTextSearchFilters.CareersLocationFilterId]: 3,
        [search_1.FullTextSearchFilters.CareersJobAreaFilterId]: 4,
        [search_1.FullTextSearchFilters.CareersExperienceLevelFilterId]: 5,
    },
    [search_1.FullTextSearcherTypes.Course]: {
        [search_1.FullTextSearchFilters.TypeFilterId]: 1,
        [search_1.FullTextSearchFilters.CourseSegmentFilterId]: 2,
        [search_1.FullTextSearchFilters.CourseLanguageFilterId]: 3,
        [search_1.FullTextSearchFilters.CourseHierarchyFilterId]: 4,
        [search_1.FullTextSearchFilters.CourseLearningEventTypeFilterId]: 5,
        [search_1.FullTextSearchFilters.CourseDeliveryTypesFilterId]: 6,
    },
    [search_1.FullTextSearcherTypes.Drawings]: {
        [search_1.FullTextSearchFilters.TypeFilterId]: 1,
        [search_1.FullTextSearchFilters.DrawingsSegmentFilterId]: 2,
        [search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterId]: 3,
        [search_1.FullTextSearchFilters.DrawingsLanguageFilterId]: 4,
        [search_1.FullTextSearchFilters.DrawingsArchivedFilterId]: 5,
        [search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterId]: 6,
        [search_1.FullTextSearchFilters.DrawingsProductGroupFilterId]: 7,
        [search_1.FullTextSearchFilters.DrawingsProductSeriesFilterId]: 8,
    },
};
exports.TYPE_TO_FILTER_MAPPING = {
    [search_1.FullTextSearcherTypes.All]: [search_1.FullTextSearchFilters.AllSegmentFilterAlias],
    [search_1.FullTextSearcherTypes.Documentation]: [
        search_1.FullTextSearchFilters.DocumentationSegmentFilterAlias,
        search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias,
        search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias,
        search_1.FullTextSearchFilters.DocumentationLanguageFilterAlias,
        search_1.FullTextSearchFilters.DocumentationCountryFilterAlias,
        search_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias,
        search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias,
        search_1.FullTextSearchFilters.DocumentationProductGroupFilterAlias,
        search_1.FullTextSearchFilters.DocumentationProductSeriesFilterAlias,
        search_1.FullTextSearchFilters.DocumentationAuthorityFilterAlias,
        search_1.FullTextSearchFilters.DocumentationArchivedFilterAlias,
        search_1.FullTextSearchFilters.DocumentationProductionSiteAlias,
    ],
    [search_1.FullTextSearcherTypes.Products]: [search_1.FullTextSearchFilters.ProductsSegmentFilterAlias],
    [search_1.FullTextSearcherTypes.Download]: [
        search_1.FullTextSearchFilters.DownloadSegmentFilterAlias,
        search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterAlias,
        search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterAlias,
        search_1.FullTextSearchFilters.DownloadProductGroupFilterAlias,
        search_1.FullTextSearchFilters.DownloadProductSeriesFilterAlias,
    ],
    [search_1.FullTextSearcherTypes.Careers]: [
        search_1.FullTextSearchFilters.CareersCountryFilterAlias,
        search_1.FullTextSearchFilters.CareersLocationFilterAlias,
        search_1.FullTextSearchFilters.CareersJobAreaFilterAlias,
        search_1.FullTextSearchFilters.CareersExperienceLevelFilterAlias,
    ],
    [search_1.FullTextSearcherTypes.Course]: [
        search_1.FullTextSearchFilters.CourseSegmentFilterAlias,
        search_1.FullTextSearchFilters.CourseHierarchyFilterAlias,
        search_1.FullTextSearchFilters.CourseLanguageFilterAlias,
        search_1.FullTextSearchFilters.CourseLearningEventTypeFilterAlias,
        search_1.FullTextSearchFilters.CourseDeliveryTypesFilterAlias,
    ],
    [search_1.FullTextSearcherTypes.Drawings]: [
        search_1.FullTextSearchFilters.DrawingsSegmentFilterAlias,
        search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterAlias,
        search_1.FullTextSearchFilters.DrawingsLanguageFilterAlias,
        search_1.FullTextSearchFilters.DrawingsArchivedFilterAlias,
        search_1.FullTextSearchFilters.DrawingsProductGroupFilterAlias,
        search_1.FullTextSearchFilters.DrawingsProductSeriesFilterAlias,
        search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias,
    ],
};
